module.exports = __webpack_public_path__ + "img/myorder.d46e8550.svg";